var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigGrayLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 194.611,
    height: 65.962,
    viewBox: "0 0 194.611 65.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3823",
    "data-name": "Group 3823",
    transform: "translate(-298.234 -63)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "ascent",
    transform: "translate(433.846 119.962)",
    fill: "#7f7f7f",
    fontSize: 36,
    fontFamily: "Montserrat-Light, Montserrat",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -58.95,
    y: 0
  }, "ascent")), /*#__PURE__*/React.createElement("g", {
    id: "Group_2962",
    "data-name": "Group 2962",
    transform: "translate(298.234 63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2739",
    "data-name": "Path 2739",
    d: "M28.124.1,22.4,9.964,49.313,57.092H60.882Z",
    transform: "translate(4.878 0.022)",
    fill: "#ba292c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2740",
    "data-name": "Path 2740",
    d: "M33,0,0,57.114H11.447L38.6,9.986Z",
    transform: "translate(0 0)",
    fill: "#eb5946"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2741",
    "data-name": "Path 2741",
    d: "M27,17.942,32.724,8.2v.122L29.557,22.2Z",
    transform: "translate(5.88 1.786)",
    fill: "#8f1f22"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigGrayLogo);
export default __webpack_public_path__ + "static/media/BigGrayLogo.9fa46580.svg";
export { ForwardRef as ReactComponent };